function Paper() {
    return {};
}

export { Paper as default };
